import { ActionEntry } from "../../../../StateDefinition/ActionState";
import { BrickPackUpgrades } from "../../../../StateDefinition/BrickPackState";

/**
 * Check if an upgrade action's corresponding brick pack has all bricks at 100% find percentage
 * @param upgradeAction - The upgrade action to check
 * @param brickPackActions - Map of all actions (to find the brick pack action)
 * @param brickPackUpgrades - Map tracking upgrade counts per brick pack
 * @returns true if all bricks in the pack are at 100% find percentage
 */
export const upgradeAtMaxCapacity = (
  upgradeAction: ActionEntry,
  brickPackActions: Map<string, ActionEntry>,
  brickPackUpgrades: BrickPackUpgrades,
): boolean => {
  // Get brick pack ID from upgrade action's outcome
  if (upgradeAction.outcome.length === 0) return false;
  const brickPackId = upgradeAction.outcome[0].brickId;

  // Get the brick pack action
  const brickPackAction = brickPackActions.get(brickPackId);
  if (!brickPackAction) return false;

  // Get current upgrade count
  const upgradeCount = brickPackUpgrades.get(brickPackId) || 0;

  // Check if ALL bricks in the pack are at 100% find percentage
  return brickPackAction.outcome.every((outcome) => {
    const basePercentage = outcome.baseChangeValue;
    const upgradeBonus = upgradeCount * 0.05;
    const totalPercentage = basePercentage + upgradeBonus;

    // Check if at or above 100% (1.0)
    return totalPercentage >= 1.0;
  });
};
